module.exports = function getResource(label, vars = []) {
    const resources = {
        limitedSupply: 'Limited Supply',
        goingFast: 'Going Fast',
        signInToAccess: 'Sign in to access',
        addFullSize: 'Add Full Size',
        addToBasket: `Add${!vars[0] ? ' to Basket' : ''}`,
        remove: 'Remove',
        writeAReview: 'Write A Review',
        free: 'FREE',
        birthday: 'birthday gift',
        priceInPoints: `${vars[0]} points`
    };

    return resources[label];
};
